<div class="max-width-p">
    <div class="body-container">
        <div class="left-part">
            <div>
                <button class="btn" [ngClass]="{'active':selectedTab === 0}" (click)="selectTab(0)">
                    <span class="ficon feather icon-user"></span>
                    <span class="button-text">{{ 'LEFT_MENU.PROFILE' | translate }}</span>
                </button>
            </div>
            <div>
                <button class="btn" [ngClass]="{'active':selectedTab === 2}" (click)="selectTab(2)">
                    <span class="ficon feather icon-map"></span>
                    <span class="button-text">{{ 'LEFT_MENU.ADDRESSES' | translate }}</span>
                </button>
            </div>
            <div>
                <button class="btn" [ngClass]="{'active':selectedTab === 3}" (click)="selectTab(3)">
                    <span class="ficon feather icon-file-text font-size-file"></span>
                    <span class="button-text">{{ 'LEFT_MENU.BILLING_ADDRESSES' | translate }}</span>
                </button>

            </div>
            <div *ngIf="canChangePassword">
                <button class="btn" [ngClass]="{'active':selectedTab === 4}" (click)="selectTab(4)">
                    <span class="ficon feather icon-lock"></span>
                    <span class="button-text">{{ 'LEFT_MENU.CHANGE_PASS' | translate }}</span>
                </button>

            </div>
        </div>
        <div class="right-part">
            <div *ngIf="selectedTab === 0 && userProfile" class="personal-data">
                <div class="personal-data-container">
                    <div class="image" style="background-image: url('{{profilePictureSrc}}');"></div>
                    <div class="buttons-containers">
                        <input
                                type="file"
                                style="display: none"
                                id="profile-picture-input"
                                accept="image/png, image/gif, image/jpeg"
                                (change)="handlePictureUpload($event)"
                                #hiddenfileinput
                        />
                        <button (click)="hiddenfileinput.click()" class="active button-profile" >
                            {{ 'PROFILE.LOAD_PIC' | translate }}
                        </button>
                        <button class="delete button-profile" (click)="deletePicture()">{{ 'PROFILE.DELETE_PIC' | translate }}</button>
                    </div>
                </div>
                <div class="person-list">
                    <div class="info-list">
                        <div>
                            <label for="name"><h6>{{ 'PROFILE.NAME_LABEL' | translate }}</h6></label>
                            <input type="text" value="{{userProfile.lastName + ' ' + userProfile.firstName}}"
                                   disabled="disabled" id="name">
                        </div>
                        <div>
                          <label for="cnp"><h6>{{ 'PROFILE.CNP_LABEL' | translate }}</h6></label>
                          <div class="masked-field">
                            <input id="cnp" [type]="showCnp ? 'text' : 'password'" value="{{userProfile.cnp}}" disabled="disabled" autocomplete="new-password">
                            <span class="mask-toggle" (click)="showCnp = !showCnp">
                              <i class="feather" [ngClass]="showCnp ? 'icon-eye-off' : 'icon-eye'"></i>
                            </span>
                          </div>
                        </div>
                        <div>
                          <label for="email"><h6>{{ 'PROFILE.EMAIL_LABEL' | translate }}</h6></label>
                          <div class="masked-field">
                            <input id="email" [type]="showEmail ? 'text' : 'password'" value="{{userProfile.email}}" disabled="disabled" autocomplete="new-password">
                            <span class="mask-toggle" (click)="showEmail = !showEmail">
                              <i class="feather" [ngClass]="showEmail ? 'icon-eye-off' : 'icon-eye'"></i>
                            </span>
                          </div>
                        </div>
                        <div>
                          <label for="employeeCode"><h6>{{ 'PROFILE.EMPLOYEE_CODE' | translate }}</h6></label>
                          <div class="masked-field">
                            <input id="employeeCode" [type]="showEmployeeCode ? 'text' : 'password'" value="{{userProfile.userEmploymentDetails.employeeCode}}" disabled="disabled" autocomplete="new-password">
                            <span class="mask-toggle" (click)="showEmployeeCode = !showEmployeeCode">
                              <i class="feather" [ngClass]="showEmployeeCode ? 'icon-eye-off' : 'icon-eye'"></i>
                            </span>
                          </div>
                        </div>
                        <div class="phone-number">
                          <label for="phoneNumber"><h6>{{ 'PROFILE.PHONE_LABEL' | translate }}</h6></label>
                          <div class="masked-field">
                            <app-masked-input
                              id="phoneNumber"
                              [masked]="!showPhoneNumber"
                              [(ngModel)]="userPhoneNumber"
                              [maxLength]="10"
                              inputMode="numeric"
                              (ngModelChange)="phoneError = ''"
                            ></app-masked-input>
                            <span class="mask-toggle" (click)="showPhoneNumber = !showPhoneNumber">
                              <i class="feather" [ngClass]="showPhoneNumber ? 'icon-eye-off' : 'icon-eye'"></i>
                            </span>
                          </div>
                            <small *ngIf="phoneError" class="error-message ">{{ phoneError }}</small>
                        </div>
                    </div>
                    <button id="save-profile-button" (click)="changePhoneNumber()" class="active" >
                        {{ 'PROFILE.SAVE_PHONE_NUMBER' | translate }}
                    </button>
                    <div class="wrong-data dark-green">
                        <div class="question bold">
                            {{ 'PROFILE.INFO_LABEL' | translate }}
                        </div>
                        <div class="contact-us">
                            {{ 'PROFILE.INFO_DETAILS' | translate }}
                            <ng-container *ngIf="companyHrEmail !== ''">
                                <span class="masked-field masked-field--inline">
                                  <a *ngIf="showHrEmail" href="mailto:{{companyHrEmail}}">{{ companyHrEmail }}</a>
                                  <span *ngIf="!showHrEmail" class="hidden-value">••••••••••</span>
                                  <span class="mask-toggle" (click)="showHrEmail = !showHrEmail">
                                    <i class="feather" [ngClass]="showHrEmail ? 'icon-eye-off' : 'icon-eye'"></i>
                                  </span>
                                </span>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="selectedTab === 2 && (billingAddresses || shippingAddresses)">
                <div class="dark-green bold border-b">{{ 'ADDRESSES.TITLE_SHIPP' | translate }}</div>
                <div class="card-container" *ngFor="let shippingAddress of shippingAddresses">
                    <div>
                        <div class="space-between align-items-center">
                            <div>
                                <span>{{ 'ADDRESSES.CONTACT_PERSON' | translate }}</span>
                                <span class="bold">{{shippingAddress.contactPersonName}}</span>,
                                {{maskPhone(shippingAddress.contactPersonPhoneNumber)}}
                            </div>
                            <div class="actions d-flex">
                                <a href="javascript: void(0);" class="link" placement="auto"
                                   ngbTooltip="{{ 'ADDRESSES.EDIT' | translate }}" title="{{ 'ADDRESSES.EDIT' | translate }}"
                                   (click)="addEditAddress('shipping', 'edit', shippingAddress)">
                                    <span class="ficon feather icon-edit-2"></span>
                                </a>
                                <a href="javascript: void(0);" class="link" placement="auto"
                                   ngbTooltip="{{ 'ADDRESSES.DELETE' | translate }}" title="{{ 'ADDRESSES.DELETE' | translate }}"
                                   (click)="deleteAddress(shippingAddress.id, 'shipping')">
                                    <span class="ficon feather icon-trash-2"></span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="address">
                        {{(shippingAddress.street) ? ('ADDRESSES.STREET_SHOW' | translate) + shippingAddress.street + ', ' : ''}}
                        {{(shippingAddress.number) ? ('ADDRESSES.STREET_NUMBER' | translate) + shippingAddress.number + ', ' : ''}}
                        {{(shippingAddress.building) ? ('ADDRESSES.STREET_BUILDING' | translate) + shippingAddress.building + ', ' : ''}}
                        {{(shippingAddress.floor) ? ('ADDRESSES.FLOOR_SHOW' | translate) + shippingAddress.floor + ', ' : ''}}
                        {{(shippingAddress.apartment) ? ('ADDRESSES.APARTMENT_SHOW' | translate) + shippingAddress.apartment + ', ' : ''}}
                        {{(shippingAddress.city) ? ('ADDRESSES.CITY_SHOW' | translate) + shippingAddress.city + ', ' : ''}}
                        {{(shippingAddress.county) ? ('ADDRESSES.COUNTRY_SHOW' | translate) + shippingAddress.county : ''}}
                    </div>
                </div>
                <div class="add-address">
                    <button (click)="addEditAddress('shipping', 'add')"
                            [disabled]="disableButton"
                    ><span
                            class="ficon feather icon-map-pin"></span>{{ 'ADDRESSES.ADD' | translate }}</button>
                </div>
                <div>
                    {{ 'ADDRESSES.NOTICE_LIMIT' | translate }}
                </div>
            </div>
            <div *ngIf="selectedTab === 3 && (billingAddresses || shippingAddresses)">
                <div class="dark-green bold border-b">{{ 'ADDRESSES.TITLE_BILL' | translate }}</div>
                <div class="card-container" *ngFor="let billingAddress of billingAddresses">
                    <div>
                        <div class="space-between align-items-center">
                            <div>
                                <span>{{ 'ADDRESSES.CONTACT_PERSON' | translate }}</span>
                                <span class="bold">{{billingAddress.contactPersonName}}</span>,
                                {{maskPhone(billingAddress.contactPersonPhoneNumber)}}
                            </div>
                            <div class="actions d-flex">
                                <a href="javascript: void(0);" class="link" placement="auto"
                                   ngbTooltip="{{ 'ADDRESSES.EDIT' | translate }}" title="{{ 'ADDRESSES.EDIT' | translate }}"
                                   (click)="addEditAddress('shipping', 'edit', billingAddress)">
                                    <span class="ficon feather icon-edit-2"></span>
                                </a>
                                <a href="javascript: void(0);" class="link" placement="auto"
                                   ngbTooltip="{{ 'ADDRESSES.DELETE' | translate }}" title="{{ 'ADDRESSES.DELETE' | translate }}"
                                   (click)="deleteAddress(billingAddress.id, 'billing')">
                                    <span class="ficon feather icon-trash-2"></span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="address">
                        {{(billingAddress.street) ? ('ADDRESSES.STREET_SHOW' | translate) + billingAddress.street + ', ' : ''}}
                        {{(billingAddress.number) ? ('ADDRESSES.STREET_NUMBER' | translate) + billingAddress.number + ', ' : ''}}
                        {{(billingAddress.building) ? ('ADDRESSES.STREET_BUILDING' | translate) + billingAddress.building + ', ' : ''}}
                        {{(billingAddress.floor) ? ('ADDRESSES.FLOOR_SHOW' | translate) + billingAddress.floor + ', ' : ''}}
                        {{(billingAddress.apartment) ? ('ADDRESSES.APARTMENT_SHOW' | translate) + billingAddress.apartment + ', ' : ''}}
                        {{(billingAddress.city) ? ('ADDRESSES.CITY_SHOW' | translate) + billingAddress.city + ', ' : ''}}
                        {{(billingAddress.county) ? ('ADDRESSES.COUNTRY_SHOW' | translate) + billingAddress.county : ''}}
                    </div>
                </div>
                <div class="add-address">
                    <button (click)="addEditAddress('billing', 'add')"
                            [disabled]="disableButton"><span
                            class="ficon feather icon-map-pin"></span>{{ 'ADDRESSES.ADD' | translate }}</button>
                </div>
                <div>
                    {{ 'ADDRESSES.NOTICE_LIMIT' | translate }}
                </div>
            </div>
            <div *ngIf="selectedTab === 4" class="change-password">
                <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()">
                    <div>
                        <h6>{{ 'CHANGE_PASS.EXISTING_PASS_LABEL' | translate }}</h6>
                        <input type="password" placeholder="{{'CHANGE_PASS.EXISTING_PASS_PLACEHOLDER' | translate}}"
                               formControlName="oldPassword" id="oldPassword">
                        <div
                                *ngIf="(f.oldPassword.dirty || f.oldPassword.touched) && f.oldPassword.errors"
                                class="invalid-feedback"
                                [ngClass]="{ 'd-block': (f.oldPassword.dirty || f.oldPassword.touched) && f.oldPassword.errors }"
                        >
                            <div *ngIf="f.oldPassword.errors.required">{{'CHANGE_PASS.PASSWORD_REQUIRED' | translate}}</div>
                        </div>
                    </div>
                    <div>
                        <h6>{{ 'CHANGE_PASS.NEW_PASS_LABEL' | translate }}</h6>
                        <input type="password"  placeholder="{{'CHANGE_PASS.NEW_PASS_PLACEHOLDER' | translate}}"
                               formControlName="newPassword" id="newPassword">
                        <div
                                *ngIf="(f.newPassword.dirty || f.newPassword.touched) && f.newPassword.errors"
                                class="invalid-feedback"
                                [ngClass]="{ 'd-block': (f.newPassword.dirty || f.newPassword.touched) && f.newPassword.errors }"
                        >
                            <div *ngIf="f.newPassword.errors.required">{{'CHANGE_PASS.PASSWORD_REQUIRED' | translate}}</div>
                        </div>
                    </div>
                    <div class="required">
                        <div *ngIf="(f.newPassword.dirty || f.newPassword.touched) &&  f.newPassword.errors">
                            <span class="p-required r1" *ngIf="f.newPassword.errors.requiredLength"><i
                                    class="fa fa-check-circle-o"></i>{{'CHANGE_PASS.PASSWORD_LENGTH' | translate}}</span>
                            <span class="p-required r2" *ngIf="f.newPassword.errors.hasUpperCase"><i
                                    class="fa fa-check-circle-o"></i>{{'CHANGE_PASS.PASSWORD_UPPERCASE' | translate}}</span>
                            <span class="p-required r3" *ngIf="f.newPassword.errors.hasLowerCase"><i
                                    class="fa fa-check-circle-o"></i>{{'CHANGE_PASS.PASSWORD_LOWERCASE' | translate}}</span>
                            <span class="p-required r4" *ngIf="f.newPassword.errors.hasNumeric"><i
                                class="fa fa-check-circle-o"></i>{{'CHANGE_PASS.PASSWORD_NUMERIC' | translate}}</span>
                            <span class="p-required r5" *ngIf="f.newPassword.errors.hasSpecialChar"><i
                                class="fa fa-check-circle-o"></i>{{'CHANGE_PASS.PASSWORD_SPECIAL_CHAR' | translate}}</span>
                            <span class="p-required r6" *ngIf="f.newPassword.errors.notEmail"><i
                                class="fa fa-check-circle-o"></i>{{'CHANGE_PASS.PASSWORD_MATCH_EMAIL' | translate}}</span>
                        </div>
                    </div>
                    <div>
                        <h6>{{ 'CHANGE_PASS.CONFIRM_PASS_LABEL' | translate }}</h6>
                        <input type="password" placeholder="{{'CHANGE_PASS.CONFIRM_PASS_PLACEHOLDER' | translate}}"
                               formControlName="confirmPassword" id="confirmPassword">
                        <div
                                *ngIf="(f.confirmPassword.dirty || f.confirmPassword.touched) && f.confirmPassword.errors"
                                class="invalid-feedback"
                                [ngClass]="{ 'd-block': (f.confirmPassword.dirty || f.confirmPassword.touched) && f.confirmPassword.errors }"
                        >
                            <div *ngIf="f.confirmPassword.errors.required">{{'CHANGE_PASS.PASSWORD_REQUIRED' | translate}}</div>
                            <div *ngIf="f.confirmPassword.errors.missMatch">{{'CHANGE_PASS.CONFIRM_PASSWORD_MISSMATCH' | translate}}</div>
                        </div>
                    </div>
                    <button class="password-button" type="submit" [disabled]="changePasswordForm.invalid" >{{ 'CHANGE_PASS.CHANGE_PASSWORD' | translate }}</button>
                </form>
            </div>
        </div>
    </div>
</div>
